import React from "react";
import FiltroTipoDocumento from "../../FiltroTipoDocumento";
import PesquisarFlutuante from "../../../../components/Prontuario/PesquisarFlutuante";
import FiltroData from "../../FiltroData";
import OpcoesProntuario from "../../OpcoesProntuario";
import {Fab, Tooltip, withStyles} from "@material-ui/core";
import {inject} from "mobx-react";
import PrintIcon from "../../../../components/Icon/Print";
import colors from "../../../../template/Colors";
import ButtonDadosImportantes from "./ButtonDadosImportantes";
import classNames from "classnames";

const OptionsProntuario = ({
  classes,
  handleOpenReceituario,
  handleDocument,
  handleClickSADT,
  handleClickGuiaInternacao,
  handleClickSolicitacaoProcedimento,
  handleClickAnamnese,
  handleClickInformacoesImportantes,
  handleClickAvaliacaoAntropometrica,
  handleClickTriagem,
  handleOpenImprimir,
  handleClickOrcamento,
  prontuarioStore,
  handleClickGuiaTGO,
  hiddenProcedimentosButton,
  hiddenModalEvahButton,
  tabSelected,
  sujeitoAtencaoId,
  handleClickEncaminhamento,
  handleClickEvahIa,
  handleClickExames,
  isTaskbarVisible
}) => {
  const isOdontograma = tabSelected === 1;
  return (
    <>
      <div className={ classNames(
        classes.contentOptions, 
        isOdontograma && classes.contentOptionsOdontograma,
        isTaskbarVisible && classes.contentOptionsWithTaskbar
      )}>
        <div className={classes.contentFuncionalidades}>
          <OpcoesProntuario
            handleOpenReceituario={handleOpenReceituario}
            handleDocument={handleDocument}
            handleClickSADT={handleClickSADT}
            handleClickSolicitacaoProcedimento={
              handleClickSolicitacaoProcedimento
            }
            hiddenModalEvahButton={hiddenModalEvahButton}
            handleClickAnamnese={handleClickAnamnese}
            handleClickAvaliacaoAntropometrica={
              handleClickAvaliacaoAntropometrica
            }
            handleClickGuiaTGO={handleClickGuiaTGO}
            handleClickTriagem={handleClickTriagem}
            hiddenProcedimentosButton={hiddenProcedimentosButton}
            handleClickGuiaInternacao={handleClickGuiaInternacao}
            handleClickOrcamento={handleClickOrcamento}
            sujeitoAtencaoId={sujeitoAtencaoId}
            handleClickEncaminhamento={handleClickEncaminhamento}
            handleClickEvahIa={handleClickEvahIa}
            handleClickExames={handleClickExames}
          />
          {
            prontuarioStore.roleEntradaProntuarioRead &&
            <ButtonDadosImportantes
              handleClickInformacoesImportantes={
                handleClickInformacoesImportantes
              }
              disabled={!sujeitoAtencaoId}
            />
          }

        </div>

          {
            !isOdontograma &&
        <div className={classes.contentButtons}>
            <>
              <FiltroTipoDocumento />

              <Fab id='prt-opp-btn-imp' className={classes.buttonYellow} onClick={handleOpenImprimir}>
                <Tooltip title="Imprimir Prontuário" placement="left">
                  <PrintIcon color="#fff" />
                </Tooltip>
              </Fab>

              <PesquisarFlutuante />
              <FiltroData />
            </>
        </div>
          }
      </div>
    </>
  );
};

const styles = (theme) => ({
  contentOptions: {
    display: "flex",
    position: "fixed",
    right: "15px",
    flexDirection: "row",
    gap: "8px",
    bottom: "90px",
    alignItems: "flex-end",
     '@media (max-width: 1250px)':{ 
        transform: 'scale(0.8) !important',
        bottom: "40px",
        zIndex: 999,
    },
    '@media (max-width: 1200px)':{ 
        transform: 'scale(0.7) !important',
        bottom: "40px",
        zIndex: 999,
    },

    '@media (max-width: 1100px)':{ 
        transform: 'scale(0.6) !important',
        bottom: "-10px",
        zIndex: 999,
    },
    '@media (max-width: 1000px)':{ 
        transform: 'scale(0.45) !important',
        bottom: "-45px",
        zIndex: 999,
    },
    '@media (max-width: 900px)':{ 
        transform: 'scale(0.35) !important',
        bottom: "-70px",
        zIndex: 999,
    },  
    
    
  },
  contentOptionsOdontograma: {
    top: "40vh",
    zIndex: 1,
  },
  contentOptionsWithTaskbar: {
    bottom: "135px !important",
    '@media (max-width: 1250px)': {
      bottom: "85px !important"
    },
    '@media (max-width: 1200px)': {
      bottom: "85px !important"
    },
    '@media (max-width: 1100px)': {
      bottom: "35px !important"
    },
    '@media (max-width: 1000px)': {
      bottom: "0px !important"
    },
    '@media (max-width: 900px)': {
      bottom: "-25px !important"
    }
  },
  contentFuncionalidades: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  contentButtons: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  buttonYellow: {
    minWidth: "40px",
    width: "40px !important",
    minHeight: "40px",
    height: "40px !important",
    background: colors.commons.yellow,
    "&:hover": {
      background: "#e0a048",
    },
  },
});

const OptionsProntuarioWithStyle = withStyles(styles)(OptionsProntuario);
export default inject(
  "prontuarioStore",
  "receituarioStore",
  "SADTStore",
  "googleAnalyticsStore"
)(OptionsProntuarioWithStyle);
